export default function quotesSingleReducer(
    state: any = {
        loading: false,
        done: false,
        error: null,
        response: {
            'id': '',
            'clientName': '',
            'inceptionDate': '',
            'quotedDate': '',
            'totalSumInsured': 1,
            'settlementBasis': '',
            'variations': [],
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Get existing locations
         */
        case 'GET_QUOTE_SINGLE_PENDING': {
            return { ...state, loading: true }
        }

        case 'GET_QUOTE_SINGLE_REJECTED': {
            return { ...state, loading: false, error: action.payload }
        }

        case 'GET_QUOTE_SINGLE_FULFILLED': {
            return {
                ...state, loading: false, done: true, error: null, response: action.payload.quote,
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/quote/view.ts